import _asyncToGenerator from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import axios, { AxiosError } from 'axios';
import * as R from 'ramda';
import { DEFAULT_HANDLER } from './httpClient';
// Retry configuration defaults
var DEFAULT_RETRY_CONFIG = {
  maxRetries: 3,
  initialDelayMs: 1000,
  // Start with 1 second delay
  maxDelayMs: 10000,
  // Maximum 10 seconds delay
  backoffFactor: 2,
  // Exponential backoff factor
  jitter: 1000,
  // Random jitter to add to delay
  retryableErrors: [// HTTP status codes to retry
  408, // Request Timeout
  429, // Too Many Requests
  500, // Internal Server Error
  502, // Bad Gateway
  503, // Service Unavailable
  504 // Gateway Timeout
  ],
  retryableErrorCodes: [// Axios error codes to retry
  AxiosError.ECONNABORTED, AxiosError.ETIMEDOUT, AxiosError.ERR_NETWORK, AxiosError.ERR_BAD_RESPONSE]
};
export var RetryService = /*#__PURE__*/function () {
  function RetryService() {
    var userConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, RetryService);

    _defineProperty(this, "config", void 0);

    this.config = _objectSpread(_objectSpread({}, DEFAULT_RETRY_CONFIG), userConfig);
  }
  /**
   * Calculate delay for next retry using exponential backoff
   */


  _createClass(RetryService, [{
    key: "calculateDelay",
    value: function calculateDelay(retryCount) {
      var delay = this.config.initialDelayMs * Math.pow(this.config.backoffFactor, retryCount) + Math.round(Math.random() * this.config.jitter);
      return Math.min(delay, this.config.maxDelayMs);
    }
    /**
     * Check if error is retryable based on configuration
     */

  }, {
    key: "isRetryableError",
    value: function isRetryableError(error) {
      var _error$response;

      // Check if it's an Axios error
      if (!axios.isAxiosError(error)) {
        return false;
      } // Check HTTP status code


      if ((_error$response = error.response) !== null && _error$response !== void 0 && _error$response.status && this.config.retryableErrors.includes(error.response.status)) {
        return true;
      } // Check Axios error code


      if (error.code && this.config.retryableErrorCodes.includes(error.code)) {
        return true;
      }

      return false;
    }
    /**
     * Sleep for specified milliseconds
     */

  }, {
    key: "sleep",
    value: function () {
      var _sleep = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ms) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve) {
                  return setTimeout(resolve, ms);
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function sleep(_x) {
        return _sleep.apply(this, arguments);
      }

      return sleep;
    }()
    /**
     * Execute request with retry logic
     */

  }, {
    key: "executeWithRetry",
    value: function () {
      var _executeWithRetry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(requestFn, onRetry) {
        var lastError, retryCount, delay;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                lastError = null;
                retryCount = 0;

              case 2:
                if (!(retryCount <= this.config.maxRetries)) {
                  _context2.next = 20;
                  break;
                }

                // Calculate delay for next retry
                delay = this.calculateDelay(retryCount++); // Wait before retrying

                _context2.next = 6;
                return this.sleep(delay);

              case 6:
                _context2.prev = 6;

                // If onRetry callback is provided, call it
                if (onRetry) {
                  onRetry({
                    error: lastError,
                    retryCount: retryCount,
                    delay: delay,
                    maxRetries: this.config.maxRetries
                  });
                }

                _context2.next = 10;
                return requestFn();

              case 10:
                return _context2.abrupt("return", _context2.sent);

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](6);
                lastError = _context2.t0; // Check if we should retry

                if (!(retryCount === this.config.maxRetries || !this.isRetryableError(_context2.t0))) {
                  _context2.next = 18;
                  break;
                }

                throw lastError;

              case 18:
                _context2.next = 2;
                break;

              case 20:
                throw lastError;

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 13]]);
      }));

      function executeWithRetry(_x2, _x3) {
        return _executeWithRetry.apply(this, arguments);
      }

      return executeWithRetry;
    }()
  }]);

  return RetryService;
}();
export var withRetry = function withRetry(instance) {
  var retryConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var retryService = new RetryService(retryConfig);
  instance.interceptors.response.clear(); // Add retry interceptor

  instance.interceptors.response.use(DEFAULT_HANDLER.onResponseFulfilled, /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(error) {
      var requestConfig, response;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (retryService.isRetryableError(error)) {
                _context3.next = 2;
                break;
              }

              throw error;

            case 2:
              _context3.prev = 2;
              // Create new request config from failed request
              requestConfig = R.clone(error.config); // Execute request with retry logic

              _context3.next = 6;
              return retryService.executeWithRetry(function () {
                return axios(requestConfig);
              }, function (_ref2) {
                var _error$response2;

                var retryCount = _ref2.retryCount,
                    delay = _ref2.delay,
                    maxRetries = _ref2.maxRetries;
                console.log("Retrying request (".concat(retryCount, "/").concat(maxRetries, ") after ").concat(delay, "ms"), error.code || ((_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.status));
              });

            case 6:
              response = _context3.sent;
              return _context3.abrupt("return", response);

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](2);
              throw _context3.t0;

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 10]]);
    }));

    return function (_x4) {
      return _ref.apply(this, arguments);
    };
  }()); // Fallback to default error handler if retry fails

  instance.interceptors.response.use(null, DEFAULT_HANDLER.onResponseRejected);
  return instance;
};